import { MatFormFieldModule } from '@angular/material/form-field';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { DatepickerTypeComponent } from './datepicker-type.component';
import { MatIconModule } from '@angular/material/icon';
import {
  DatepickerMaskDirective,
  MatFormFieldYearPickerDirective,
} from '@lockton-apps/shared/ui/lui';
import { format } from 'date-fns';

@NgModule({
  declarations: [DatepickerTypeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatFormFieldModule,
    DatepickerMaskDirective,
    MatFormFieldYearPickerDirective,

    FormlyModule.forChild({
      types: [
        {
          name: 'datepicker',
          component: DatepickerTypeComponent,
          wrappers: ['mat-form-field', 'addons'],
          defaultOptions: {
            validation: {
              messages: {
                matDatepickerMin: (args) =>
                  `Must not be before ${format(args.min, 'dd/MM/yyyy')}`,
                matDatepickerMax: (args) =>
                  `Must not be after ${format(args.max, 'dd/MM/yyyy')}`,
                matDatepickerFilter: () => 'Please select a valid date',
              },
            },
          },
        },
      ],
    }),
    MatIconModule,
  ],
})
export class DatepickerTypeModule {}
